import type { IconSvgObject } from './types';

const CheckLineIcon: IconSvgObject = [
  ["path", { d: "M5 11.2592L7.58583 13.9568C8.2525 14.6523 8.58583 15.0001 9.00004 15.0001C9.41425 15.0001 9.74759 14.6523 10.4143 13.9568L19 5.00006", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 19H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CheckLineIcon;
